import { render, staticRenderFns } from "./material.vue?vue&type=template&id=101bd36c&scoped=true&"
import script from "./material.vue?vue&type=script&lang=ts&"
export * from "./material.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101bd36c",
  null
  
)

export default component.exports